import React from 'react';
import { Col } from 'antd';
import { Colors } from '../../config';

const LabelWithField = ({
    labelClass,
    inputClass,
    type,
    placeholder,
    labeltext,
    field,
    fieldState,
    prop,
    disabled,
    onBlur,
    bgColor,
    onChange, // Add onChange prop
}) => {
    return (
        <div className="flex flex-col py-4 w-full">
            <label className={labelClass} style={{ color: Colors.LabelColor }}>
                {labeltext}
            </label>
            <input
                type={type}
                {...field}
                {...prop}
                onBlur={onBlur}
                onChange={(e) => {
                    field.onChange(e); // This ensures react-hook-form updates
                    if (onChange) onChange(e); // If provided, call the custom onChange
                }}
                className={`pl-2.5 outline-none ${inputClass}`}
                style={{ background: bgColor ? bgColor : Colors.LightGray }}
                placeholder={placeholder}
                disabled={disabled}
            />
        </div>
    );
};

export default LabelWithField;
